export default {"src":"/_next/static/media/arrow.9e9a09e2.svg","height":14,"width":20};